import {UcoastEl} from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ShopByStyle extends UcoastEl {
  static htmlSelector = 'shop-by-style'

  slider: Number
  lists: NodeListOf<HTMLElement>
  products: NodeListOf<HTMLElement>
  previous: HTMLElement
  next: HTMLElement
  options: NodeListOf<HTMLElement>

  constructor() {
    super()

    this.slider = 1

    this.lists = q.rl('[data-uc-shop-by-style-list]', this)
    this.products = q.rl('[data-uc-shop-by-style-product]', this)
    this.options = q.rl('[data-uc-shop-by-style-option]', this)

    this.previous = q.rs('[data-uc-shop-by-style-previous]', this)
    this.next = q.rs('[data-uc-shop-by-style-next]', this)

    this.previous.addEventListener('click', this.back.bind(this))
    this.next.addEventListener('click', this.go.bind(this))

    this.options.forEach(option =>
      option.addEventListener('click', this.activate.bind(this))
    )
  }

  // todo - this one was done by another team, I'd recommend cleaning this up to be typesafe
  back() {
    if (this.slider > 1) {
      this.slider--
      this.refresh()
    } else {
      this.next.click()
    }
  }

  go() {
    if (this.slider < this.lists.length) {
      this.slider++
      this.refresh()
    } else {
      this.previous.click()
    }
  }

  refresh() {
    this.lists.forEach(list => {
      const index = +q.oa(list, 'data-uc-shop-by-style-list')

      list.classList.toggle('active', this.slider === index)
    })

    let found_product = false

    this.products.forEach(product => {
      const prefix = q.oa(product, 'data-uc-shop-by-style-product')

      if (prefix?.startsWith(`${this.slider}-`)) {
        product.classList.toggle('active', !found_product)
        found_product = true
      } else {
        product.classList.remove('active')
      }
    })

    let found_option = false

    this.options.forEach(option => {
      const prefix = q.oa(option, 'data-uc-shop-by-style-option')

      if (prefix?.startsWith(`${this.slider}-`)) {
        option.classList.toggle('active', !found_option)
        found_option = true
      } else {
        option.classList.remove('active')
      }
    })
  }

  activate(event: Event) {
    event.preventDefault()

    const target = q.rt<Event, HTMLButtonElement>(event)
    const selected = q.oa(target, 'data-uc-shop-by-style-option')

    this.options.forEach(option => {
      const id = q.oa(option, 'data-uc-shop-by-style-option')

      option.classList.toggle('active', id === selected)
    })

    this.products.forEach(product => {
      const id = q.oa(product, 'data-uc-shop-by-style-product')

      product.classList.toggle('active', id === selected)
    })
  }
}
